import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "profile-fill",
  "use": "profile-fill-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"profile-fill\">\n  <path fill-rule=\"evenodd\" d=\"M389,322.3a2.471,2.471,0,0,0,2.242-2.649c0-2.029-1-2.649-2.242-2.649s-2.243.62-2.243,2.649A2.471,2.471,0,0,0,389,322.3h0Zm0,0,4.951,3.9-1.132-2.572a0.568,0.568,0,0,0-.255-0.275l-1.756-.922a0.109,0.109,0,0,0-.12.01,2.748,2.748,0,0,1-3.377,0,0.11,0.11,0,0,0-.12-0.01l-1.756.922a0.568,0.568,0,0,0-.255.275l-1.132,2.572a0.573,0.573,0,0,0,.043.543,0.562,0.562,0,0,0,.474.26h8.869a0.562,0.562,0,0,0,.474-0.26,0.573,0.573,0,0,0,.043-0.543h0Zm0,0\" transform=\"translate(-384 -317)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/profile-fill.svg
// module id = null
// module chunks = 